// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"26bb9257","71":"abbb3b33"}[chunkId] + ".chunk.css";
};